import React from 'react';
import { withStyles } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { withRouter } from '../../../../../util/router-compatibility';
import withJanusTokenReady from '../../withJanusTokenReady';
import { CasePlanDetailsContent } from './components/CasePlanDetailsContent';
import { CasePlanDetailsError } from './components/CasePlanDetailsError';
import { useCasePlanDetailsHook } from './useCasePlanDetailsHook';
import styles from './CasePlanDetails.styles';

function CasePlanDetails({ classes }) {
  const { casePlanId } = useParams();
  const {
    cardProps,
    isViewOnly,
    isSectionsLoading,
    error,
    collapsedSections,
    handleBack,
    handleToggleCollapse,
    handleAddWidget,
    handleEditorsClick,
    handleExportClick,
    isExportOpen,
    handleExportClose,
    handleExportSubmit,
    planStatus,
    isEditor,
    handleStatusSelect,
    pendingStatus,
    handleStatusConfirm,
    handleStatusCancel,
    sectionApi,
  } = useCasePlanDetailsHook(casePlanId);

  const showError = error && !cardProps && !isSectionsLoading;
  if (showError) {
    return <CasePlanDetailsError classes={classes} error={error} onBack={handleBack} />;
  }

  return (
    <CasePlanDetailsContent
      classes={classes}
      cardProps={cardProps}
      isViewOnly={isViewOnly}
      isSectionsLoading={isSectionsLoading}
      collapsedSections={collapsedSections}
      onBack={handleBack}
      onToggleCollapse={handleToggleCollapse}
      onAddWidget={handleAddWidget}
      onEditorsClick={handleEditorsClick}
      onExportClick={handleExportClick}
      isExportOpen={isExportOpen}
      onExportClose={handleExportClose}
      onExportSubmit={handleExportSubmit}
      status={planStatus}
      isEditor={isEditor}
      onStatusSelect={handleStatusSelect}
      pendingStatus={pendingStatus}
      onStatusConfirm={handleStatusConfirm}
      onStatusCancel={handleStatusCancel}
      sectionApi={sectionApi}
    />
  );
}

const StyledCasePlanDetails = withRouter(withStyles(styles)(CasePlanDetails));

export default withJanusTokenReady(StyledCasePlanDetails);
